import { render } from "./otherfooter.vue?vue&type=template&id=1b2dc1f8"
import script from "./otherfooter.vue?vue&type=script&lang=js"
export * from "./otherfooter.vue?vue&type=script&lang=js"

import "./otherfooter.vue?vue&type=style&index=0&id=1b2dc1f8&lang=scss"

import exportComponent from "../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__